import ApiService from '../../common/ApiCalls'
import {setItemToSessionStorage} from './sessionStorageManager'
import {isObjectEmpty, recordFormatter, today} from './miscellaneousService'
import uuid from 'react-uuid'
import dayjs from 'dayjs'

export const trimFullName = (fullName) => {
    if(!Boolean(fullName)){
        return ['','']
    }
    let formattedName = fullName.replace(/\s/g, '')
        .replace(/([a-z])([A-Z])/g, '$1 $2')

    if(formattedName.length === 1){
        formattedName[1] = ''
    }
    return formattedName
}

export const formatDocumentList = (documentsArray) => {
    let formattedDocumentsData = {}
    for(let i = 0; i < documentsArray.length; i++){
        formattedDocumentsData[documentsArray[i].title] = documentsArray[i].url
    }
    return JSON.stringify(formattedDocumentsData)
}

export const documentsListFormatter = (documentsArray) => {
    let formattedDocumentsData = {}
    for(let i = 0; i < documentsArray.length; i++){
        formattedDocumentsData[documentsArray[i].title] = documentsArray[i].url
    }
    return JSON.stringify(formattedDocumentsData)
}

export const assignedGroupFormatter = (assignedGroupNameList) => {
    const formattedList = []
    for(let i = 0; i < assignedGroupNameList.length; i++){
        const keyword = {searchInput: assignedGroupNameList[i]}
        ApiService().searchGroups(keyword)
            .then((res)=>{
                formattedList.push(res.data.data[0])
            })
    }
    return formattedList
}

export const addedRemovedDetector = (originalArray, endArray) => {
    const added = endArray.filter(i => JSON.stringify(originalArray).indexOf(JSON.stringify(i)) === -1)
    const removed = originalArray.filter(i => JSON.stringify(endArray).indexOf(JSON.stringify(i)) === -1)
    return {added, removed}
}

export const duplicateRemover = (baseArray, referenceArray) => {
    const resultBaseArray = [...baseArray]
    baseArray.forEach( (baseArrayItem, index) => {
        if(referenceArray.indexOf(baseArrayItem) >= 0){
            resultBaseArray.splice(index, 1)
        }
    })
    return resultBaseArray
}

export const selectedUnselectedDetector = (originalArray, endArray) => {
    let selected = []
    let unselected = []

    for(let i = 0; i < originalArray.length; i++){
        if(!originalArray[i].selected && endArray[i].selected) selected.push(endArray[i])
        if(originalArray[i].selected && !endArray[i].selected) unselected.push(endArray[i])
    }

    return {selected, unselected}
}

export const removeSelectedOptions = (searchResults, selectedOptions) => {
    const removedSelectedOptions = searchResults.filter(searchResult =>
        JSON.stringify(selectedOptions).indexOf(JSON.stringify(searchResult)) === -1)
    return removedSelectedOptions
}

export const formatServiceInputFromId = async (importId) => {
  const data = {dataId: importId}
  let selectedServiceList = {}

  const pendingData = await ApiService().getPendingDataImport(data)
  const {location_id, selected_service_list, pending_data_id, initiator_email, account_id} = pendingData
  console.log(pendingData)
  setItemToSessionStorage('pendingDataId', pending_data_id)
  setItemToSessionStorage('initiatorEmail', initiator_email)

  const quickViewData = await ApiService().getQuickView(location_id)
  const selectedLocation = {
    location_id,
    name: quickViewData?.data?.loc_name || '' // CB: Fix to avoid exception. Improve this.
  }
  setItemToSessionStorage('selectedLocation', selectedLocation)
  const accountData = await ApiService().getContractById(account_id)

  const selectedAccount = {
    account_id,
    name: accountData?.data?.data.name || ''  // CB: Fix to avoid exception. Improve this.
  }
  setItemToSessionStorage('selectedClient', selectedAccount)

  const serviceTypeData = await ApiService().getAllServiceTypes()
  for(let i = 0; i < serviceTypeData.length; i++){
    if(serviceTypeData[i].service_type !== 'User'){
        selectedServiceList[serviceTypeData[i].service_type] = []
    }
  }



  for(let i = 0; i < selected_service_list.length; i++){
    const response = await ApiService().getServiceById(selected_service_list[i])
    const { service_type } = response?.name || ''

    selectedServiceList[service_type] = [...selectedServiceList[service_type], response?.name]
  }

  setItemToSessionStorage('selectedServiceList', selectedServiceList)
}

export const formatContactInputFromId = async (importId) => {
    const data = {dataId: importId}

    await ApiService().getPendingDataImport(data)
        .then(async (res)=>{
            const {location_id, new_contact_list, existing_contact_list, pending_data_id, initiator_email, account_id} = res
            console.log(account_id)

            await ApiService().getContractById(account_id)
                .then((res)=>{
                    const selectedAccount = {
                        account_id: account_id,
                        name: res.data.data.name
                    }
                    setItemToSessionStorage('selectedClient', selectedAccount)
                })

            setItemToSessionStorage('pendingDataId', pending_data_id)
            setItemToSessionStorage('initiatorEmail', initiator_email)

            await ApiService().getQuickView(location_id)
                .then((res)=>{
                    const selectedLocation = {
                        location_id: location_id,
                        name: res.data.loc_name
                    }
                    setItemToSessionStorage('selectedLocation', selectedLocation)
                })

            // newContact
            let contactTypeReference
            let newContact = {}
            await ApiService().getAllContactType()
                .then((res) => {
                    contactTypeReference = res
                    for (let i = 0; i < res.length; i++) {
                        if (res[i].contact_type !== 'User') {
                            newContact[res[i].contact_type] = []
                        }
                    }
                })
                .then(() => {
                    for (let i = 0; i < new_contact_list.length; i++) {
                        newContact[new_contact_list[i].contactType] = [
                            ...newContact[new_contact_list[i].contactType],
                            new_contact_list[i]
                        ]
                    }
                })

            const findContactType = (contact_type_id) => {
                return contactTypeReference.find(el => el.contact_type_id === contact_type_id)
            }

            // existingContact
            for (let i = 0; i < existing_contact_list.length; i++) {
                await ApiService().getPartyById(existing_contact_list[i])
                    .then((res) => {
                        const contactData = res.data[0]

                        const {
                            id, description, email, job_title_id, first_name, last_name,
                            phone, records, type_id
                        } = contactData
                        const formattedRecordList = recordFormatter(records)
                        const contactType = findContactType(type_id)

                        const newDataFromSearch = {
                            id: uuid(),
                            contactId: id,
                            firstName: first_name,
                            lastName: last_name,
                            jobTitle: job_title_id,
                            assignedDate: today,
                            phoneNumber: phone,
                            email: email,
                            description: description ? description : '',
                            records: formattedRecordList,
                            contactTypeId: type_id,
                            contactType: contactType.contact_type
                        }

                        newContact[contactType.contact_type] = [
                            ...newContact[contactType.contact_type],
                            newDataFromSearch
                        ]
                    })
            }

            setItemToSessionStorage('newContact', newContact)
        })
}

export const formatNewLocationData = async (importId) => {
    const data = {dataId: importId}

    await ApiService().getPendingDataImport(data)
        .then(async (res)=> {
            const {new_location, new_contact_list, existing_contact_list, pending_data_id, selected_service_list,
                account_id, initiator_email} = res
            setItemToSessionStorage('pendingDataId', pending_data_id)
            setItemToSessionStorage('initiatorEmail', initiator_email)


            await ApiService().getContractById(account_id)
                .then((res)=>{
                    const selectedAccount = {
                        account_id: account_id,
                        name: res.data.data.name
                    }
                    setItemToSessionStorage('selectedClient', selectedAccount)
                })

            // newLocation
            setItemToSessionStorage('newLocation', new_location)

            // newContact
            let contactTypeReference
            let newContact = {}
            await ApiService().getAllContactType()
                .then((res) => {
                    contactTypeReference = res
                    for (let i = 0; i < res.length; i++) {
                        if (res[i].contact_type !== 'User') {
                            newContact[res[i].contact_type] = []
                        }
                    }
                })
                .then(() => {
                    for (let i = 0; i < new_contact_list.length; i++) {
                        newContact[new_contact_list[i].contactType] = [
                            ...newContact[new_contact_list[i].contactType],
                            new_contact_list[i]
                        ]
                    }
                })

            const findContactType = (contact_type_id) => {
                return contactTypeReference.find(el => el.contact_type_id === contact_type_id)
            }

            // existingContact
            for (let i = 0; i < existing_contact_list.length; i++) {
                await ApiService().getPartyById(existing_contact_list[i])
                    .then((res) => {
                        const contactData = res.data[0]

                        const {
                            id, description, email, job_title_id, first_name, last_name,
                            phone, records, type_id
                        } = contactData
                        const formattedRecordList = recordFormatter(records)
                        const contactType = findContactType(type_id)

                        const newDataFromSearch = {
                            id: uuid(),
                            contactId: id,
                            firstName: first_name,
                            lastName: last_name,
                            jobTitle: job_title_id,
                            assignedDate: today,
                            phoneNumber: phone,
                            email: email,
                            description: description ? description : '',
                            records: formattedRecordList,
                            contactTypeId: type_id,
                            contactType: contactType.contact_type
                        }

                        newContact[contactType.contact_type] = [
                            ...newContact[contactType.contact_type],
                            newDataFromSearch
                        ]
                    })
            }

            setItemToSessionStorage('newContact', newContact)

            // selectedServiceList
            let selectedServiceList = {}
            await ApiService().getAllServiceTypes()
                .then((res) => {
                    for (let i = 0; i < res.length; i++) {
                        if (res[i].service_type !== 'User') {
                            selectedServiceList[res[i].service_type] = []
                        }
                    }
                })
                .then(async () => {
                    for (let i = 0; i < selected_service_list.length; i++) {
                        await ApiService().getServiceById(selected_service_list[i]) 
                            .then((res) => {
                                const resobj =res?.name || ''
                                const serviceType = resobj?.service_type || ''
                                selectedServiceList[serviceType] = [...selectedServiceList[serviceType], resobj]
                            })
                    }
                })
                .then(() => {
                    setItemToSessionStorage('selectedServiceList', selectedServiceList)
                })
        })
}

export const formatNewClientData = async (importId) => {
    const data = {dataId: importId}

    await ApiService().getPendingDataImport(data)
        .then(async (res)=>{
            const {new_service_list, new_account, new_location, new_contact_list, existing_contact_list,
                pending_data_id, initiator_email} = res
            setItemToSessionStorage('pendingDataId', pending_data_id)
            setItemToSessionStorage('initiatorEmail', initiator_email)


            // newClientProfile
            setItemToSessionStorage('newClientProfile', new_account)

            // newServiceSet
            let newServiceSet = {}
            for(let i = 0; i < new_service_list.length; i++){
                if(newServiceSet[new_service_list[i].serviceType]){
                    newServiceSet[new_service_list[i].serviceType] = [
                        ...newServiceSet[new_service_list[i].serviceType],
                        new_service_list[i]
                    ]
                }else{
                    newServiceSet[new_service_list[i].serviceType] = [
                        new_service_list[i]
                    ]
                }
            }
            setItemToSessionStorage('newServiceSet', newServiceSet)

            // newLocation
            setItemToSessionStorage('newLocation', new_location)

            // newContact
            let contactTypeReference
            let newContact = {}
            await ApiService().getAllContactType()
                .then((res)=>{
                    contactTypeReference = res
                    for(let i = 0; i < res.length; i++){
                        if(res[i].contact_type !== 'User'){
                            newContact[res[i].contact_type] = []
                        }
                    }
                })
                .then(()=>{
                    for(let i = 0; i < new_contact_list.length; i++){
                        newContact[new_contact_list[i].contactType] = [
                            ...newContact[new_contact_list[i].contactType],
                            new_contact_list[i]
                        ]
                    }
                })

            const findContactType = (contact_type_id) => {
                return contactTypeReference.find(el => el.contact_type_id === contact_type_id)
            }

            // existingContact
            for(let i = 0; i < existing_contact_list.length; i++){
                await ApiService().getPartyById(existing_contact_list[i])
                    .then((res)=>{
                        const contactData = res.data[0]

                        const {id, description, email, job_title_id, first_name, last_name,
                            phone, records, type_id} = contactData
                        const formattedRecordList = recordFormatter(records)
                        const contactType = findContactType(type_id)

                        const newDataFromSearch = {
                            id: uuid(),
                            contactId: id,
                            firstName: first_name,
                            lastName: last_name,
                            jobTitle: job_title_id,
                            assignedDate: today,
                            phoneNumber: phone,
                            email: email,
                            description: description ? description : '',
                            records: formattedRecordList,
                            contactTypeId: type_id,
                            contactType: contactType.contact_type
                        }

                        newContact[contactType.contact_type] = [
                            ...newContact[contactType.contact_type],
                            newDataFromSearch
                        ]
                    })
            }

            setItemToSessionStorage('newContact', newContact)


            // selectedServiceList
            const selectedServiceList = {}
            await ApiService().getAllServiceTypes()
                .then((res) => {
                    for (let i = 0; i < res.length; i++) {
                        if (res[i].service_type !== 'User') {
                            selectedServiceList[res[i].service_type] = []
                        }
                    }
                })
                .then(async () => {
                    for(let i = 0; i < new_service_list.length; i++){
                        if(new_service_list[i].selected){
                            selectedServiceList[new_service_list[i].serviceType] = [
                                ...selectedServiceList[new_service_list[i].serviceType],
                                new_service_list[i]
                            ]
                        }

                    }
                })
                .then(() => {
                    setItemToSessionStorage('selectedServiceList', selectedServiceList)
                })



        })
}

export const formatSignInDate = (signInDate) => {
    if(signInDate){
        return dayjs(signInDate).format("L")
    }
    return ''
}

export const formatSignInTime = (signInDate) => {
    if(signInDate){
        const hour = dayjs(signInDate).format("hh")
        const minute = dayjs(signInDate).format("mm")
        const amPm = dayjs(signInDate).format("A")

        return `${hour}:${minute} ${amPm}`
    }

    return ''
}


/**
 *
 * @param date {string}
 * @param format {string} Refer to day.js documentation
 * @return {string}
 */
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
export const formatDate = (date) => {
    const timezone = dayjs.tz.guess()
    dayjs.tz.setDefault(timezone)
    return dayjs(date).format('MMM DD, YYYY')
}

export const formatDateInSelectedFormat = (date, format) => {
    const timezone = dayjs.tz.guess()
    dayjs.tz.setDefault(timezone)
    return dayjs(date).format(format)
}

export const getTimeZone = () => {
    return dayjs.tz.guess()
}

export const formatDateAndTime = (date) => {
    const timezone = dayjs.tz.guess()
    dayjs.tz.setDefault(timezone)
    return dayjs(date)
}


export const formatDashboardData = (data) => {
    const {dashboardData, commentData} = data || {}

    return {
      comment: {
          value: commentData?.dashboard_comment || '',
          date: commentData?.created_at || '',
          commenter: commentData?.commenter_name || ''
      },
      nps: {
          value: dashboardData?.clientscore?.clientScore || '',
          date: dashboardData?.clientscore?.date || ''
      },
      inspection: {
          value: dashboardData?.inspectionscore?.inspectionScore || '',
          date: dashboardData?.inspectionscore?.date || ''
      },
      compliance: {
          value: dashboardData?.compliancescore?.complianceScore || '',
          date: dashboardData?.compliancescore?.date || ''
      },
      reports: {
          value: dashboardData?.reportcount?.reportCount || '',
          date: dashboardData?.reportcount?.date || ''
      },
      incidents: {
          value: dashboardData?.incidentcount?.incident_count || '',
          date: dashboardData?.incidentcount?.date || ''
      }
    }
}

export const formatWidgetsData = (data = {}) => {
  return {
      nps: {
          value: data?.clientscore?.clientScore || '',
          date: data?.clientscore?.date || ''
      },
      inspection: {
          value: data?.inspectionscore?.inspectionScore || '',
          date: data?.inspectionscore?.date || ''
      },
      compliance: {
          value: data?.compliancescore?.complianceScore || '',
          date: data?.compliancescore?.date || ''
      },
      reports: {
          value: data?.reportcount?.reportCount || '',
          date: data?.reportcount?.date || ''
      },
      incidents: {
          value: data?.incidentcount?.incident_count || '',
          date: data?.incidentcount?.date || ''
      }
  }
}

export const formatCommentList = (commentList, locationId) => {
    const formattedCommentList = []
    for(let i = 0; i < commentList.length; i++){
        const {name, comment, type, date, id, originalDate} = commentList[i]
        formattedCommentList.push({
            commentId: id,
            commenterName: name,
            comment,
            commenterType: type,
            date: formatDateAndTime(date),
            locationId,
            isDateEdited: date !== originalDate
        })
    }
    return formattedCommentList
}


export const formatDashboardMetricsList = (dashboardMetricsList, locationId) => {
    const formattedDashboardMetricsList = []
    for(let i = 0; i < dashboardMetricsList.length; i++){
        const {date, id, clientScore, reportCount, inspectionScore, incidentCount, complianceScore, originalDate} = dashboardMetricsList[i]
        formattedDashboardMetricsList.push({
            dataPointId: id,
            date: formatDateAndTime(date),
            clientScore,
            inspectionScore,
            complianceScore,
            reportCount,
            incidentCount,
            locationId,
            isDateEdited: date !== originalDate
        })
    }
    return formattedDashboardMetricsList
}

export const formatDashboardMetricsDirectInsert = (
    dashboardMetrics,
    locationId,
    createdBy
) => {
    const {
        date,
        clientScore,
        reportCount,
        inspectionScore,
        incidentCount,
        complianceScore
    } = dashboardMetrics

    return {
        clientScore,
        inspectionScore,
        complianceScore,
        reportCount,
        incidentCount,
        locationId,
        date: formatDateAndTime(date),
        createdBy
    }
}

export const formatPendingDashboardData = (pendingDashboardData) => {
    const {data, details} = pendingDashboardData.data

    if(!details){
        return data
    }

    if(data.dashboard_data){
        return {
            ...data,
            dashboard_data: {
                ...data.dashboard_data,
                ...details
            }
        }
    }

    if(data.comment_data){
        console.log({
            ...data,
            comment_data: {
                ...data.comment_data,
                ...details
            }
        })
        return {
            ...data,
            comment_data: {
                ...data.comment_data,
                ...details
            }
        }
    }
}

export const formatAutocompleteOptions = (options, idKey, nameKey) => {
    let formattedList = []
    for(let i = 0; i < options.length; i++){
        if(options[i][nameKey]){
            formattedList.push({id: options[i][idKey], name: options[i][nameKey]})
        }
    }
    return formattedList
}

export const formatIconName = (iconNumber) => {
    const iconNameList = [
        'houseS',
        'houseL',
        'flat',
        'highriseS',
        'highriseM',
        'highriseL',

        'postOffice',
        'hospital',
        'bank',
        'store',
        'restaurant',
        'hotel',

        'aircraft',
        'ship',
        'train',
        'truck',
        'bus',
        'car',

        'radioTower',
        'school',
        'janitor',
        'construction',
        'tools',
        'default']
    return iconNameList[iconNumber]
}

export const getIconIndex = (iconName) => {
    const iconNameList = [
        'houseS',
        'houseL',
        'flat',
        'highriseS',
        'highriseM',
        'highriseL',

        'postOffice',
        'hospital',
        'bank',
        'store',
        'restaurant',
        'hotel',

        'aircraft',
        'ship',
        'train',
        'truck',
        'bus',
        'car',

        'radioTower',
        'school',
        'janitor',
        'construction',
        'tools',
        'default']
    return iconNameList.findIndex((icon) => icon === iconName)
}

export const upperCase = (string, defaultString) => {
    if(string){
        return string.toUpperCase()
    }
    return defaultString
}

export const concatenateAddress = (addressObject) => {
    if(!addressObject||isObjectEmpty(addressObject)){
        return ''
    }

    const keyList = Object.keys(addressObject)
    let concatenatedAddress = ''
    for(let i = 0; i < keyList.length; i++){
        if(addressObject[keyList[i]] && addressObject[keyList[i]] !== 'null'){
            concatenatedAddress = concatenatedAddress.concat(' ', addressObject[keyList[i]])
        }
    }

    return concatenatedAddress
}

export const formatName = (name) => {
    if(typeof name !== 'string') return ''
    const characterCount = name.length
    if(characterCount <= 3) {
        return name
    }else{
        const initials = name.split(" ").map((n)=>n[0])
        if(initials.length <= 3){
            return initials.join('')
        }else{
            return `${initials[0]} ${initials[1]} ${initials[2]}`
        }
    }
}

export const groupAssignedLocationsByAccount = (assignedLocationList) => {
    const groupedLocations = {}
    for(let i = 0; i < assignedLocationList.length; i++){
        const {account_name} = assignedLocationList[i]
        if(groupedLocations[account_name]){
            groupedLocations[account_name].push(assignedLocationList[i])
        }else{
            groupedLocations[account_name] = [assignedLocationList[i]]
        }
    }
    return groupedLocations
}

export const titleCase = (string) => {
    if(string.length > 1){
        return string.toLowerCase().split(' ').map((word) => {
            return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    }
    return ''
}
